import React from "react";

const PortfolioSection = ({ projects = [] }) => {
  return (
    <section id="portfolio" className="py-20 ">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-5xl font-extrabold text-gray-900 dark:text-white">
          Explore My Latest Work
        </h2>
        <p className="mt-4 text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          I empower clients globally to embrace modern technology and elevate
          customer experiences.
        </p>

        {/* Portfolio Items */}
        <div
          className={` mt-12 grid ${
            projects.length === 1
              ? "flex justify-center m-auto"
              : "grid-cols-1 md:grid-cols-2"
          } gap-16`}
        >
          {projects.map((project, index) => (
            <div
              key={index}
              className="flex flex-col items-center space-y-6 md:space-y-0 md:space-x-8 gap-8 max-w-96"
            >
              <img
                src={project.projectImage}
                alt={`${project.projectName} - Project Screenshot`}
                className="w-full rounded-lg shadow-lg dark:shadow-gray-800 object-cover"
                loading="lazy"
                width="400"
                height="300"
              />
              <div className="text-left">
                <h3 className="text-2xl font-bold text-gray-800 dark:text-white leading-tight">
                  {project.projectName}
                </h3>
                <p className="mt-2 text-gray-600 dark:text-gray-300">
                  {project.projectDescription}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
